import React from 'react'
import { IconProps } from '../../../common/types'

const ThreeDotIcon: React.FC<IconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="none" />
      <path
        d="M13.3333 7.66667C13.3333 7.29848 13.0349 7 12.6667 7C12.2985 7 12 7.29848 12 7.66667C12 8.03485 12.2985 8.33333 12.6667 8.33333C13.0349 8.33333 13.3333 8.03485 13.3333 7.66667Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 12.3334C13.3333 11.9652 13.0349 11.6667 12.6667 11.6667C12.2985 11.6667 12 11.9652 12 12.3334C12 12.7016 12.2985 13.0001 12.6667 13.0001C13.0349 13.0001 13.3333 12.7016 13.3333 12.3334Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 17.0002C13.3333 16.632 13.0349 16.3335 12.6667 16.3335C12.2985 16.3335 12 16.632 12 17.0002C12 17.3684 12.2985 17.6668 12.6667 17.6668C13.0349 17.6668 13.3333 17.3684 13.3333 17.0002Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ThreeDotIcon
